import { render } from "./mySettings.vue?vue&type=template&id=8259c072"
import script from "./mySettings.vue?vue&type=script&lang=js"
export * from "./mySettings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__